import * as appConstants from '../constants/appConstant'
import { http } from '../utils/http';
import axios from 'axios'
import auth from '../utils/auth';

const login = (userCode, password) => {
  return new Promise((resolve, reject) => {
    function loginFunc() {
      if (userCode === 'wu.xm.1') {
        resolve({
          code: 0,
          data: {
            userCode,
            token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTE0Njg4MDAsInNob3J0TmFtZSI6ImppbmxpYW5nLnpoYW5nQGdpZW50ZWNoLmNvbSIsInVzZXJuYW1lIjoiamlubGlhbmcuemhhbmdAZ2llbnRlY2guY29tIn0.ZtlA2ylcQtT_JjEhG4lTE8tQSPzi4SyiAx9pCrVKFVA',
            pspToken: 'test',
            permissionKeys: appConstants.permissionKey,
          },
        });
      } else {
        reject();
      }
    }
    setTimeout(loginFunc, 0);
  });
};

const logout = (params) => {
  const url = '/api/v1/sso/logout'
  return http.post(url, params)
};


const validateCode = (code) => {
  const url = '/api/v1/sso/login'
  return http.post(url, { code: code })
}
const refreshToken = () => {
  const authInfo = auth.getAuthInfo();
  return new Promise((resolve, reject) => {
    axios.post(`${window.g.REFRESH_URI}?applicationId=${window.g.APP_ID}&refreshToken=${auth.getRefresh()}`, {}, {
      headers: {
        "Auth-Type": "ssofed",
        "Ocp-Apim-Subscription-Key": window.g.SUBSCRIPTION_KEY_LOGIN,
        "Authorization": `Bearer ${authInfo.token}`,
        "PSP-Authorization": `${authInfo.pspToken}`
      }
    }).then(res => {
      if (res.data.code === 0) {
        resolve(res.data);
      } else {
        reject(res.data);
      }
    }).catch(error => {
      reject(error);
    });
  })
}
const loginByPwd = (params) => {
  const url = '/api/v1/sso/loginByPwd'
  return http.post(url, params)
};
const getThemeStyle = () => {
  const url = '/market/config/storage/detail'
  return http.post(url)
};
const updatePwdByUser = (params) => {
  const url = '/api/v1/sso/updatePwdByUser'
  return http.post(url, params)
};
const getChatBiPermission = () => {
    const url = '/chatbi/permission'
    return http.get(url)
};
export default { login, logout, validateCode, refreshToken, loginByPwd, getThemeStyle, updatePwdByUser, getChatBiPermission};
